<script lang="ts">
    import type {Employee} from "$lib/types/employee";
    import employeeComplete from "$lib/utils/employeeComplete";

    export let item: Employee

    $: color = employeeComplete(item) ? 'bg-green-500' : 'bg-red-500'
</script>

<div class="rounded-2xl w-5 h-5 {color}"/>